import { _api } from "@iconify/react";

// 🎨 Icônes intégrées au site : les dessins des seules icônes utilisées (assets/icones/iconify.json),
// dans un fichier à part du site, téléchargé à la première icône affichée (gardé en cache, il ne
// grossit pas le fichier principal ; tour 38 : plus au démarrage, l'accueil n'en affiche aucune). Iconify les demande à ce module au lieu de son
// API : plus aucune requête vers api.iconify.design, l'adresse IP des visiteurs n'y part plus
// (avant : 7 à 15 requêtes par page). Une icône absente des données ne s'affiche pas et n'est
// demandée à personne. Ajouter une icône : npm run icones (scripts/icones.js). Licences des
// collections : CREDITS-ICONES.md.
let collections;
const loadCollections = () => {
  if (!collections) collections = import(/* webpackChunkName: "icones" */ "../assets/icones/iconify.json").then((m) => m.default || m);
  return collections;
};

// Réponse au format de l'API d'Iconify : les icônes demandées d'une collection
const answer = (data, { prefix, icons }) => {
  const set = data.find((c) => c.prefix === prefix);
  const found = {};
  const aliases = {};
  for (const name of icons) {
    if (set?.icons[name]) found[name] = set.icons[name];
    else if (set?.aliases?.[name]) aliases[name] = set.aliases[name];
  }
  const missing = icons.filter((name) => !found[name] && !aliases[name]);
  return {
    prefix,
    icons: found,
    ...(Object.keys(aliases).length ? { aliases } : {}),
    ...(set?.width ? { width: set.width } : {}),
    ...(set?.height ? { height: set.height } : {}),
    ...(missing.length ? { not_found: missing } : {}),
  };
};

const localModule = {
  prepare: (provider, prefix, icons) => [{ type: "icons", provider, prefix, icons }],
  send: (host, params, callback) => {
    loadCollections()
      .then((data) => callback("success", answer(data, params)))
      .catch(() => callback("abort", 500));
  },
};

export const installIcons = () => {
  _api.setAPIModule("", localModule);
  // Filet de sécurité : jamais d'appel réseau d'Iconify
  _api.setFetch(() => Promise.reject(new Error("Icônes intégrées au site, aucun appel à l'API Iconify")));
};
